class accountBalance {
    constructor(
        conceptId,
        name,
        amount,
        appliesIn
        
    ) {
            this.conceptId = conceptId,
            this.name = name,
            this.amount = amount,
            this.appliesIn = appliesIn
    }
    static fromJson({
        conceptoId,
        nomConcepto,
        cantidad,
        aplicaEn
    }) {
        return new accountBalance(
            conceptoId,
            nomConcepto,
            cantidad,
            aplicaEn
        );
    }
}
export default accountBalance;
